export const envs = { VITE_BASE_URL: '/youtube-reload', VITE_ENVIRONMENT: 'production', SENTRY_DSN: 'https://b2496345bc7f2f29c170bb9aa540aa59@o1146294.ingest.sentry.io/4505847571415040', 'VERSION': '4.6.0' };
